export default __webpack_public_path__ + "static/media/sounds/trcReminders.mp3";